'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRestorePage = function MdRestorePage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 30c4.6 0 8.4-3.7 8.4-8.4s-3.8-8.2-8.4-8.2c-3 0-5.5 1.5-7 3.8l-2.1-2.2v6.6h6.6l-2.7-2.6c1-1.9 2.9-3.1 5.2-3.1 3.2 0 5.9 2.5 5.9 5.7s-2.7 5.9-5.9 5.9c-2 0-3.7-1-4.8-2.5h-2.9c1.3 3 4.3 5 7.7 5z m3.4-26.6l10 10v20c0 1.8-1.6 3.2-3.4 3.2h-20c-1.8 0-3.4-1.4-3.4-3.2l0.1-26.8c0-1.8 1.5-3.2 3.3-3.2h13.4z' })
        )
    );
};

exports.default = MdRestorePage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/restore-page.js
// module id = 3723
// module chunks = 168707334958949